<grid-handler-view
  [panels]="panels"
  [volumetries]="null"
  [gridProperties]="gridProperties"
  [editMode]="editMode"
  [subheaderSelector]="subheaderSelector"
  scope="investments"
  (onGenerateAction)="generateSheet($event)"
>
</grid-handler-view>